import type { LookupParams } from '@/domain/base';
import type { PartyLookupParams, PartyLookupResult } from '@/domain/person';
import type { UserLookup } from '@/domain/user';
import { crudService } from '@/services/apiClient';
import { api } from '@/utils/configuration';
import type { GenericAbortSignal } from 'axios';

const LookupService = {
  user: (params?: LookupParams, signal?: GenericAbortSignal) =>
    crudService.get<UserLookup[]>(`${api.USER_URL}/lookup`, { params, signal }),

  party: (params?: PartyLookupParams, signal?: GenericAbortSignal) =>
    crudService.get<PartyLookupResult[]>(`${api.PARTIES_URL}/lookup`, { params, signal }),
};

export default LookupService;
